<template lang="pug">
  .basic-category
    .basic-category__content
      .basic-category__item(
        v-for="item,index in data"
        :key="index"
      )
        .basic-category__item__title
          span {{ item.category_name }}
          span(@click="view(item)")
            i.iconfont.icon-show
            span {{ $t('查看案例') }}
        .basic-category__item__content
          span {{ item.scope_name }}
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default () {
        return {}
      }
    }
  },
  computed: {
    isVendor () {
      return this.$store.state.common.user.is_vendor
    }
  },
  methods: {
    view (item) {
      this.$store.commit('vendor/setCategoryName', item.category_name)
      this.$store.commit('vendor/setCategoryId', item.category_id)
      const url = this.isVendor
        ? '/information/view/category-info'
        : '/vendor/info/basic-info/category-info'
      this.$router.push(url)
    }
  }
}
</script>

<style lang="stylus">
.basic-category__content
  width: 920px
  padding-left: 40px
  display: grid
  grid-template-columns: 1fr 1fr
  grid-row-gap: 20px
  grid-column-gap: 40px

.basic-category__item
  width: 400px
  height: 85px
  padding 20px
  box-shadow: 0 1px 5.5px 1.5px rgba(119, 151, 178, 0.16)

.basic-category__item__title
  display flex
  align-items center
  justify-content space-between
  margin-bottom 25px
  > span:nth-child(1)
    font-size 15px
  > span:nth-child(2)
    color $main
    cursor pointer
    > i
      margin-right 10px

.basic-category__edit
  padding: 20px 0
  display: flex
  justify-content: center
</style>
